// returns a binder for className of an element
// switcher=false adds the class when the value is falsy
export default function className(elementClassName, switcher) {
  if (switcher === void 0) {
    switcher = true;
  }
  return {
    on: null,
    getValue: function getValue() {
      var value = this.classList.contains(elementClassName);
      return switcher ? value : !value;
    },
    setValue: function setValue(value) {
      // IE 11 ignores toggle's second argument
      if (switcher ? value : !value) this.classList.add(elementClassName);else this.classList.remove(elementClassName);
    }
  };
}